import { useEffect, useRef } from "react";

export const useDynamicBottomHeight = (dependencies: any[] = [], padding: number = 20) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const updateBottomHeight = () => {
            if (containerRef.current) {
                const height = containerRef.current.offsetHeight;
                document.documentElement.style.setProperty(
                    "--bottom-container-height",
                    `${height + padding}px`,
                );
            }
        };

        updateBottomHeight();
        window.addEventListener("resize", updateBottomHeight);
        return () => window.removeEventListener("resize", updateBottomHeight);
    }, dependencies);

    return containerRef;
};
